// Work-breakdown view (wireframe 03) — render_wbs emits a `wbs-tree`
// envelope; the WbsWidget renders four modes: Hierarchy (boxed tree),
// Indented tree (text outline), Mindmap (iframe to Markmap), and a
// Sunburst placeholder.

import { WbsWidget } from "../components/widgets/WbsWidget.js";
import { useShell } from "../components/ShellContext.js";
import { useTool } from "../lib/useTool.js";
import { ErrorState, Skeleton } from "./common.js";

export default function WbsView() {
  const { project } = useShell();
  const { env, loading, error, refetch } = useTool("render_wbs", { project });

  if (loading) return <Skeleton lines={4} />;
  if (error) return <ErrorState error={error} onRetry={refetch} />;
  if (!env) return <ErrorState error="render_wbs returned no envelope" onRetry={refetch} />;

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-lg border border-slate-200 bg-white">
      <WbsWidget data={env.data} />
    </div>
  );
}
